import httpClient from "./httpClient";

export default {
  // Restaurants
  async getRestaurants() {
    const response = await httpClient.get(`/restaurants`);
    return response.data;
  },

  async deleteRestaurant(restaurantId) {
    const response = await httpClient.delete(`/restaurants/${restaurantId}`);
    return response.data;
  },

  async createRestaurant(restaurant) {
    const response = await httpClient.post(`/restaurants`, {
      ...restaurant
    });
    return response.data;
  },

  async updateRestaurant(restaurant) {
    const response = await httpClient.put(`/restaurants/${restaurant.id}`, {
      ...restaurant
    });
    return response.data;
  }
};
